import React from "react";
// import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
// import {useAuth} from "../../context/AuthProvider"

const PrivateRoute = ({children, allowedGroups: aGroups, sessionGroups, isLoading, sessionData}) => {

  let allowedAccess = aGroups.some((e) =>
    sessionGroups.includes(e)
  );

  if(!isLoading && (!sessionData|| !allowedAccess)) return <Navigate to={"/"}/>;

  
  return children;
};

export default PrivateRoute;
